import { Language, TText } from "api/type";
import { LanguageContext } from "contexts";
import React, { useContext } from "react";

// text variables
const text: TText = {
  text1: {
    en: "Put the camera down on a surface waist high.",
    es: "Coloque la cámara sobre una superficie a la altura de la cintura.",
  },
  text2: {
    en: "Find a bright space and an empty background.",
    es: "Busca un espacio luminoso y un fondo vacío.",
  },
  text3: {
    en: "Note: ",
    es: "Nota: ",
  },
  text4: {
    en: "Use camera phone for better results.",
    es: "Utilice la cámara del teléfono para obtener mejores resultados.",
  },
};

const Screen1: React.FC = () => {
  const language = useContext<Language>(LanguageContext)[0];

  if (!language) return null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "auto",
      }}
    >
      <img
        src="https://clinic-os.com/flow-assets%2Fbody-scan-instructions%2Fscan-instructions1.png"
        alt=""
        style={{
          width: "auto",
          height: "auto",
          maxWidth: "322px",
          aspectRatio: "1",
        }}
      />
      <p
        style={{
          fontSize: "14px",
          color: "black",
          fontWeight: 400,
          width: "322px",
        }}
      >
        {text.text1[language]}
        <br />
        {text.text2[language]}
        <br />
        <span style={{ color: "red" }}>{text.text3[language]}</span>
        {text.text4[language]}
      </p>
    </div>
  );
};

export default Screen1;
